import React, { useEffect, useState } from "react";
import "./Header.css";
import { FaPhoneAlt, FaBars, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useLocalContext } from "../../context/LocalContext";

const Header = () => {
  const navigate = useNavigate();
  const { webinfo = {} } = useLocalContext();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const brandName = webinfo.name || "Your Brand";
  const phoneText = webinfo.phone || "+91 80000 00000";
  const phoneHref = webinfo.phonecall
    ? `tel:${webinfo.phonecall}`
    : phoneText
    ? `tel:${phoneText}`
    : "tel:+918000000000";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigate = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  const handleCall = () => {
    // window.location.href = phoneHref;
  };

  return (
    <header className={`header ${scrolled ? "header--scrolled" : ""}`}>
      <div className="header-inner">
        {/* Logo / brand */}
        <button
          className="logo"
          onClick={() => handleNavigate("/")}
          aria-label={`${brandName} home`}
        >
          <span className="logo-mark" />
          <span className="logo-text-group">
            <span className="logo-text-main">{brandName}</span>
            <span className="logo-text-sub">Growth, not guesswork.</span>
          </span>
        </button>

        {/* Desktop nav */}
        <nav className="nav-links" aria-label="Main navigation">
          <button className="nav-item" onClick={() => handleNavigate("/")}>
            Home
          </button>
          <button
            className="nav-item"
            onClick={() => handleNavigate("/services")}
          >
            Services
          </button>
          <button
            className="nav-item"
            onClick={() => handleNavigate("/our-strategies")}
          >
            Strategies
          </button>
          <button
            className="nav-item"
            onClick={() => handleNavigate("/about")}
          >
            About
          </button>
          <button
            className="nav-item"
            onClick={() => handleNavigate("/process")}
          >
            Process
          </button>
          <button
            className="nav-item"
            onClick={() => handleNavigate("/contact")}
          >
            Contact
          </button>
        </nav>

        {/* Desktop actions */}
        <div className="nav-actions">
          <button className="call-btn" onClick={handleCall}>
            <FaPhoneAlt className="call-icon" />
            <span className="call-label">{phoneText}</span>
          </button>
          <button
            className="primary-btn"
            onClick={() => handleNavigate("/services")}
          >
            Book a strategy call
          </button>
        </div>

        {/* Hamburger (mobile) */}
        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Slide-in Menu */}
      <div className={`mobile-menu ${menuOpen ? "show" : ""}`}>
        <div className="mobile-nav">
          <button
            className="nav-item"
            onClick={() => handleNavigate("/")}
          >
            Home
          </button>
          <button
            className="nav-item"
            onClick={() => handleNavigate("/services")}
          >
            Services
          </button>
          <button
            className="nav-item"
            onClick={() => handleNavigate("/our-strategies")}
          >
            Strategies
          </button>
          <button
            className="nav-item"
            onClick={() => handleNavigate("/about")}
          >
            About
          </button>
          <button
            className="nav-item"
            onClick={() => handleNavigate("/process")}
          >
            Process
          </button>
          <button
            className="nav-item"
            onClick={() => handleNavigate("/contact")}
          >
            Contact
          </button>

          <div className="mobile-nav-actions">
            <button className="call-btn full-width" onClick={handleCall}>
              <FaPhoneAlt className="call-icon" />
              <span className="call-label">{phoneText}</span>
            </button>
            <button
              className="primary-btn full-width"
              onClick={() => handleNavigate("/services")}
            >
              Book a strategy call
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
